/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";

const TrianglePointer = ({ inputClasses, ...props }) => (
  <div style={{ overflow: "auto", margin: "-1px" }} className={`TrianglePointer ${inputClasses}`} {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="11"
      viewBox="0 0 25 11"
      fill="none"
      style={{ display: "block" }}
    >
      <path d="M12.5 0L24.1913 10.5H0.808657L12.5 0Z" fill="#E7E6E6" />
    </svg>
  </div>
);

TrianglePointer.propTypes = {
  inputClasses: PropTypes.string
};

TrianglePointer.defaultProps = {
  inputClasses: null
};
export default TrianglePointer;
